<div (click)="toggleExpand()"
  class="expandable align-button-and-text">
  <button mat-icon-button>
    <mat-icon>{{expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
  </button>
  {{taakType | titlecase}}
</div>
@if (expanded) {
  <div
    class="categorieen">
    @for (categorie of dienst.getCategorieen(); track categorie) {
      <zah-categorie
        [categorie]="categorie"
        [clientCategorie]="clientDienst.getCategorie(categorie.getId())">
      </zah-categorie>
    }
  </div>
}
